const rateFields = [
    {
        label: 'Code',
        key: 'code',
        validators: [
            {validate: 'required'}
        ]
    },
    // {
    //     label: 'Nina Code',
    //     key: 'nina_code',
    //     validators: [
    //         {validate: 'required'}
    //     ]
    // },
    // {
    //     label: 'Rate',
    //     key: 'rate',
    //     validators: [
    //         {validate: 'required'}
    //     ]
    // },
    {
        label: 'Category',
        key: 'category',
        validators: [
            {validate: 'required'}
        ]
    },
    {
        label: 'Description',
        key: 'description',
    },
    {
        label: 'UOM',
        key: 'uom',
        validators: [
            // {validate: 'required'}
        ]
    },
    {
        label: 'Display Order',
        key: 'display_order',
        validators: [
            {
                validate: 'regex_matches',
                regex: '^[0-9.]+$',
                error: 'must be a number'
            }
        ]
    },
    {
        label: 'Status',
        key: 'status',
        type: 'select',
        options: [
            { value: 1, label: 'ACTIVE' },
            { value: 0, label: 'ARCHIVED' },
        ],
        validators: [
            // {validate: 'required'}
        ]
    },
];

module.exports = {
    flatfileLicense: '969260e5-c819-4425-b901-3872c1c60c5c',
    /**
     * Rate field should not be populated on master rates (only on contract rates)
     */
    rateFlatfileOptions: {
        disableManualInput: true,
        type: "data",
        fields: [
            ...rateFields,
        ],
    },
    contractRateFlatfileOptions: {
        disableManualInput: true,
        type: "data",
        fields: [
            {
                label: 'Rate',
                key: 'rate',
                validators: [
                    { validate: 'required' }
                ]
            },
            ...rateFields
        ],
    },
    codeFlatfileOptions: {
        disableManualInput: true,
        type: "data",
        allowCustom: true,
        fields: [
            {
                label: 'Type',
                key: 'type',
                type: 'select',
                options: [
                    { value: 'ACTIVITY', label: 'ACTIVITY' },
                    { value: 'ASSET', label: 'ASSET' },
                    { value: 'FAILURE', label: 'FAILURE' },
                    { value: 'orderType', label: 'Order Type' },
                    { value: 'PROBLEM', label: 'PROBLEM' },
                    { value: 'REPAIR', label: 'REPAIR' },
                    { value: 'RESPONSE', label: 'RESPONSE' },
                    { value: '[SYSTEM][ORDER][CODE_CHAIN]', label: '[SYSTEM][ORDER][CODE_CHAIN]' },
                    { value: 'RATE', label: 'RATE' },
                ],
                validators: [
                    // {validate: 'required'}
                ]
            },
            {
                label: 'Group',
                key: 'group',
                validators: [
                    // {validate: 'required'}
                ]
            },
            {
                label: 'Code',
                key: 'code',
                validators: [
                    {validate: 'required'}
                ]
            },
            {
                label: 'Name',
                key: 'name',
                validators: [
                    {validate: 'required'}
                ]
            },
            {
                label: 'Status',
                key: 'status',
                validators: [
                    {
                        validate: 'regex_matches',
                        regex: '^[0-9]+$',
                        error: 'must be a number'
                    }
                ]
            },
        ]
    },
};



// WEBPACK FOOTER //
// ./src/config/index.js